// Lib
import React from 'react';
import { useLocation } from 'react-router-dom';

// Components
import Button from '../../../Button';
import Feather from '../../../Feather';

// Hooks
import useUser from '../../../../hooks/useUser';

// Styles
import { useStyles } from './FooterButtonsStyles';

const FooterButtons = ({
  onClickBack = () => {},
  onClickNext = () => {},
  backTitle,
  nextTitle = 'Next Step',
  nextButtonDisabled,
  loading,
  withPrevButton = true,
  centerSlot = null,
}) => {
  const { isKiteUser } = useUser();
  const { classes } = useStyles({ withPrevButton });
  const { pathname } = useLocation();

  return (
    <div className={classes.buttons}>
      {withPrevButton && (
        <Button
          id="prev-button"
          onClick={() => onClickBack(pathname)}
          variant="text"
          className={classes.prevButton}>
          <Feather
            nativeColor={!isKiteUser}
            type="backArrow"
            printType="stroke"
          />
          {backTitle}
        </Button>
      )}
      {centerSlot}
      <Button
        loadingIndicator="Loading…"
        loading={loading}
        id="next-button"
        disabled={nextButtonDisabled}
        onClick={onClickNext}>
        {nextTitle}
      </Button>
    </div>
  );
};

export default FooterButtons;
